import { Box, Flex, Link, Modal, Text } from '~/design-system';
import { Trans } from '@lingui/macro';
import React from 'react';
import Button from '../../design-system/Button/Button';

/**
 * @param {object} props
 * @param {() => void} props.onCancelImport
 * @param {() => void} props.onSaveForLater
 * @param {() => void} props.onKeepEditing
 */
export default function CancelImportDialog({
  onCancelImport,
  onSaveForLater,
  onKeepEditing,
}) {
  return (
    <Modal
      onClose={onKeepEditing}
      aria-label="Cancel import"
      //@ts-ignore - sx not in IntrinsicAttributes
      sx={{
        backgroundColor: 'White',
        maxWidth: '500px',
        minHeight: 'initial',
        marginX: 'auto',
      }}
    >
      <Box sx={{ paddingTop: 3, paddingX: 3 }}>
        <Text variant="semiTitle">
          {/* @ts-ignore */}
          <Trans>Cancel import?</Trans>
        </Text>
        <Text sx={{ marginTop: 2 }}>
          {/* @ts-ignore */}
          <Trans>
            Are you sure you want to stop this import? Your work will be lost.
          </Trans>
        </Text>
      </Box>

      <Flex
        sx={{
          alignItems: 'center',
          borderTop: '1px solid #e5e5e5;',
          marginTop: 4,
          paddingY: 3,
          paddingX: 3,
        }}
      >
        <Link onClick={onSaveForLater} sx={{ cursor: 'pointer' }}>
          {/* @ts-ignore */}
          <Trans>Save for later</Trans>
        </Link>
        <Box sx={{ marginLeft: 'auto' }}>
          <Button
            variant="secondary"
            onClick={onKeepEditing}
            sx={{ marginRight: 2, cursor: 'pointer' }}
          >
            {/* @ts-ignore */}
            <Trans>Keep editing</Trans>
          </Button>
          <Button
            variant="primary"
            onClick={onCancelImport}
            autoFocus
            sx={{ cursor: 'pointer' }}
          >
            {/* @ts-ignore */}
            <Trans>Cancel import</Trans>
          </Button>
        </Box>
      </Flex>
    </Modal>
  );
}
